import {
  Grid,
  Box,
  InputLabel,
  FormControl,
  Typography,
  FormHelperText,
} from "@mui/material";
import AddContactsModalStyles from "../AddContactsModal.styles";
import { useContext, useMemo } from "react";
import CustomAutoComplete from "global/components/CustomAutoComplete/CustomAutoComplete";
import { ContactContext } from "../Context";
import { isTruthy } from "helpers/methods";

const DynamicCsvFieldMapping = () => {
  const classes = AddContactsModalStyles;
  const { parsingCsvData, csvColumn, setCsvColumn } =
    useContext(ContactContext);

  const handleOnChange = (event: any, newValue: any) => {
    const name = event.target.id.split("-")[0];
    setCsvColumn((prev: any) =>
      prev.map((item: any) => {
        if (item.field === name) {
          item.fieldMapping = isTruthy(newValue) ? newValue.label : "";
          item.error = "";
        }
        return item;
      })
    );
  };

  const columnTypeData = useMemo(() => {
    return (
      Object.entries(parsingCsvData.csvData).map(([key, value]) => ({
        key,
        value,
      })) || []
    );
  }, [parsingCsvData.csvData]);

  return (
    <Box>
      <Grid container spacing={2} mt={0.5}>
        {csvColumn.map((col: any, index: number) => (
          <>
            <Grid item xs={12} sm={6} key={index} sx={classes.gridItem}>
              <Box sx={classes.gridItemBox}>
                <InputLabel
                  sx={{
                    fontWeight: 400,
                    color: "#475569",
                  }}
                  required={col.required ?? false}
                >
                  {col.name}
                </InputLabel>
                <FormControl
                  variant="outlined"
                  style={{ minWidth: "200px" }}
                  size="small"
                >
                  <CustomAutoComplete
                    id={col.field}
                    name={col.field}
                    options={columnTypeData.map((column) => ({
                      label: column.key,
                    }))}
                    onChange={handleOnChange}
                    placeHolder={`Select ${col.name}`}
                    value={col.fieldMapping}
                    clearIcon={false}
                  />
                  {isTruthy(col.error) && (
                    <FormHelperText error sx={{ marginLeft: "0px" }}>
                      {col.error}
                    </FormHelperText>
                  )}
                </FormControl>
              </Box>
            </Grid>
          </>
        ))}
      </Grid>
      {/* <Typography
        variant="subtitle2"
        color={"#FF9436"}
        pt={1}
        sx={{
          opacity: 0.9,
        }}
      >
        * Select a field you want to map with colum
      </Typography> */}
    </Box>
  );
};

export default DynamicCsvFieldMapping;
